import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	create: {
		isLoading: false,
		error: ''
	},
	get: {
		tags: [],
		error: '',
		hasBeenLoaded: false,
		isLoading: false
	}
};

export const tagsSlice = createSlice({
	name: 'tags',
	initialState,
	reducers: {
		createTag: (state) => {
			state.create.isLoading = true;
		},
		createTagCompleted: (state) => {
			state.create.isLoading = false;
			state.create.error = '';
		},
		createTagFailed: (state, action) => {
			state.create.isLoading = false;
			state.create.error = action.payload;
		},
		getTags: (state) => {
			state.get.isLoading = true;
		},
		getTagsCompleted: (state, action) => {
			state.get.isLoading = false;
			state.get.tags = action.payload;
			state.get.hasBeenLoaded = true;
			state.get.error = '';
		},
		getTagsFailed: (state, action) => {
			state.get.isLoading = false;
			state.get.hasBeenLoaded = false;
			state.get.error = action.payload;
		}
	}
});

export const {
	createTag,
	createTagCompleted,
	createTagFailed,
	getTags,
	getTagsCompleted,
	getTagsFailed
} = tagsSlice.actions;

export default tagsSlice.reducer;
